import { render, staticRenderFns } from "./ActivitySubscriptionsTable.vue?vue&type=template&id=65e94da3&scoped=true&"
import script from "./ActivitySubscriptionsTable.vue?vue&type=script&lang=js&"
export * from "./ActivitySubscriptionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e94da3",
  null
  
)

export default component.exports